<template>
  <div
    class="oep"
    :class="{ 'oep--solto': standalone }"
  >
    <div class="oep__head">
      <span class="oep__title">Equipamentos</span>
      <button
        type="button"
        class="btn btn-sm btn-link oep__refresh"
        :disabled="carregando"
        @click="carregar"
      >
        {{ carregando ? 'Atualizando...' : 'Atualizar' }}
      </button>
    </div>

    <div
      v-if="carregando && !resumo"
      class="oep__vazio"
    >
      <b-spinner small />
    </div>

    <template v-else>
      <div
        v-if="retencoesAbertas.length"
        class="oep__aviso oep__aviso--retido"
      >
        <feather-icon
          icon="AlertTriangleIcon"
          size="15"
        />
        <div>
          <strong>Ficou equipamento retido.</strong>
          <div
            v-for="r in retencoesAbertas"
            :key="r.id"
            class="oep__ret"
          >
            <div class="oep__ret-topo">
              <span class="oep__ret-qtd">{{ r.pending_quantity }}&times;</span>
              <strong>{{ r.equipment ? r.equipment.name : '—' }}</strong>
              <small
                v-if="r.returned_quantity"
                class="oep__ret-parcial"
              >{{ r.returned_quantity }} de {{ r.quantity }} j&aacute; voltou</small>
              <span class="oep__selo-pendente">Pendente</span>
            </div>
            <div class="oep__ret-linha">
              {{ destino(r) }}
              <template v-if="r.responsible_name">
                &middot; recebido por {{ r.responsible_name }}
              </template>
              &middot; {{ r.team ? r.team.name : 'sem equipe' }}
            </div>
            <div class="oep__ret-linha oep__ret-acoes">
              <SignatureViewer
                v-if="r.has_signature"
                :url="urlAssinatura(r)"
                :titulo="`Assinatura — ${r.equipment ? r.equipment.name : ''}`"
              />
              <template v-if="!readonly">
                <button
                  type="button"
                  class="btn btn-sm btn-link p-0 oep__acao"
                  :disabled="salvando"
                  @click="abrirEdicao(r)"
                >
                  Editar
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-link p-0 oep__acao oep__acao--baixa"
                  :disabled="salvando"
                  @click="abrirBaixa(r)"
                >
                  Dar baixa
                </button>
              </template>
            </div>

            <div
              v-if="baixando === r.id"
              class="oep__form oep__form--baixa"
            >
              <div class="oep__form-campos">
                <div class="oep__campo oep__campo--qtd">
                  <label class="oep__label">Voltou</label>
                  <input
                    v-model.number="baixa.quantity"
                    type="number"
                    class="form-control form-control-sm"
                    min="1"
                    :max="r.pending_quantity"
                  >
                </div>
                <div class="oep__campo">
                  <label class="oep__label">Quem devolveu</label>
                  <input
                    v-model="baixa.responsible_name"
                    type="text"
                    class="form-control form-control-sm"
                    maxlength="180"
                    placeholder="Opcional"
                  >
                </div>
              </div>
              <div class="oep__form-campos mt-50">
                <div class="oep__campo">
                  <label class="oep__label">Observa&ccedil;&atilde;o</label>
                  <input
                    v-model="baixa.notes"
                    type="text"
                    class="form-control form-control-sm"
                    maxlength="255"
                    placeholder="Opcional"
                  >
                </div>
              </div>
              <div
                v-if="baixaParcial(r)"
                class="oep__parcial"
              >
                Sobram {{ r.pending_quantity - baixa.quantity }} retido(s) &mdash; a reten&ccedil;&atilde;o continua aberta.
              </div>
              <div class="oep__form-acoes">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  :disabled="salvando"
                  @click="baixando = null"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-success"
                  :disabled="salvando || !baixaValida(r)"
                  @click="confirmarBaixa(r)"
                >
                  {{ salvando ? 'Salvando...' : 'Confirmar baixa' }}
                </button>
              </div>
            </div>

            <div
              v-if="editando === r.id"
              class="oep__form oep__form--edicao"
            >
              <div class="oep__form-campos">
                <div class="oep__campo">
                  <label class="oep__label">{{ unidades.length ? 'Unidade' : 'Unidade (texto)' }}</label>
                  <select
                    v-if="unidades.length"
                    v-model="edicao.establishment_id"
                    class="form-control form-control-sm"
                  >
                    <option :value="null">
                      N&atilde;o cadastrada &mdash; descrever
                    </option>
                    <option
                      v-for="u in unidades"
                      :key="u.id"
                      :value="u.id"
                    >
                      {{ u.establishment_name }}
                    </option>
                  </select>
                  <input
                    v-else
                    v-model="edicao.location"
                    type="text"
                    class="form-control form-control-sm"
                    maxlength="180"
                  >
                </div>
                <div class="oep__campo">
                  <label class="oep__label">Profissional respons&aacute;vel</label>
                  <input
                    v-model="edicao.responsible_name"
                    type="text"
                    class="form-control form-control-sm"
                    maxlength="180"
                  >
                </div>
              </div>
              <div
                v-if="unidades.length && !edicao.establishment_id"
                class="oep__form-campos mt-50"
              >
                <div class="oep__campo">
                  <label class="oep__label">Descreva a unidade</label>
                  <input
                    v-model="edicao.location"
                    type="text"
                    class="form-control form-control-sm"
                    maxlength="180"
                  >
                </div>
              </div>
              <div class="oep__form-acoes">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  :disabled="salvando"
                  @click="editando = null"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  :disabled="salvando"
                  @click="salvarEdicao(r)"
                >
                  {{ salvando ? 'Salvando...' : 'Salvar' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-else
        class="oep__aviso oep__aviso--ok"
      >
        <feather-icon
          icon="CheckCircleIcon"
          size="15"
        />
        <span>Nenhum equipamento retido nesta ocorrência.</span>
      </div>

      <div
        v-if="retencoesDevolvidas.length"
        class="oep__recuperados"
      >
        {{ retencoesDevolvidas.length }} retenç{{ retencoesDevolvidas.length > 1 ? 'ões' : 'ão' }}
        já recuperada{{ retencoesDevolvidas.length > 1 ? 's' : '' }}.
      </div>

      <div
        v-if="!readonly && !equipamentoDasEquipes.length"
        class="oep__sem-equipamento"
      >
        <div class="oep__sub">
          Lan&ccedil;ar equipamento que ficou
        </div>
        <p class="mb-50">
          Nenhuma equipe desta ocorr&ecirc;ncia tem equipamento alocado, ent&atilde;o n&atilde;o h&aacute;
          o que reter. O equipamento vem do cadastro da equipe.
        </p>
        <router-link
          v-for="t in equipesDespachadas"
          :key="t.id"
          class="btn btn-sm btn-outline-primary mr-50 mb-50"
          :to="{ name: 'EditTeam', params: { id: t.id } }"
        >
          Alocar equipamento em {{ t.name }}
        </router-link>
        <p
          v-if="!equipesDespachadas.length"
          class="mb-0 text-muted"
        >
          Esta ocorr&ecirc;ncia tamb&eacute;m n&atilde;o tem equipe despachada.
        </p>
      </div>

      <div
        v-if="!readonly && equipamentoDasEquipes.length"
        class="oep__equipes"
      >
        <div class="oep__sub">
          Com as equipes
        </div>
        <div
          v-if="posicaoLiberadora"
          class="oep__gate"
        >
          Reten&ccedil;&atilde;o liberada a partir de <strong>{{ posicaoLiberadora }}</strong>.
        </div>
        <div
          v-for="a in equipamentoDasEquipes"
          :key="a.id"
          class="oep__linha"
          :class="{ 'oep__linha--bloqueada': !podeReter(a) }"
        >
          <span class="oep__pastilha">{{ a.quantity }}</span>

          <div class="oep__item">
            <div class="oep__nome">
              {{ a.equipment ? a.equipment.name : '—' }}
            </div>
            <div class="oep__meta">
              <span
                v-if="detalheEquipamento(a.equipment)"
                class="oep__detalhe"
              >{{ detalheEquipamento(a.equipment) }}</span>
              <span class="oep__chip">{{ a.team ? a.team.name : 'sem equipe' }}</span>
            </div>
          </div>

          <button
            v-if="alvo !== a.id"
            type="button"
            class="btn btn-sm"
            :class="podeReter(a) ? 'btn-outline-warning' : 'btn-outline-secondary'"
            :disabled="salvando || !podeReter(a)"
            :title="podeReter(a) ? 'Registrar retenção' : textoBloqueio"
            @click="abrirFormulario(a)"
          >
            Reter
          </button>
        </div>

        <div
          v-if="alvoAtual"
          class="oep__form"
        >
          <div class="oep__form-topo">
            Reter de <strong>{{ nomeEquipamento(alvoAtual.equipment) }}</strong>
            <small class="text-muted">
              (a equipe est&aacute; com {{ alvoAtual.quantity }})
            </small>
          </div>
          <div class="oep__form-campos">
            <div class="oep__campo oep__campo--qtd">
              <label class="oep__label">Quantidade</label>
              <input
                v-model.number="form.quantity"
                type="number"
                class="form-control form-control-sm"
                min="1"
                :max="alvoAtual.quantity"
              >
            </div>
            <div
              v-if="unidades.length"
              class="oep__campo"
            >
              <label class="oep__label">Unidade</label>
              <select
                v-model="form.establishment_id"
                class="form-control form-control-sm"
              >
                <option :value="null">
                  N&atilde;o cadastrada &mdash; descrever
                </option>
                <option
                  v-for="u in unidades"
                  :key="u.id"
                  :value="u.id"
                >
                  {{ u.establishment_name }}
                </option>
              </select>
            </div>
            <div
              v-else
              class="oep__campo"
            >
              <label class="oep__label">Unidade</label>
              <input
                v-model="form.location"
                type="text"
                class="form-control form-control-sm"
                maxlength="180"
                placeholder="Ex: CER Barra da Tijuca"
              >
            </div>
          </div>
          <div class="oep__form-campos mt-50">
            <div
              v-if="unidades.length && !form.establishment_id"
              class="oep__campo"
            >
              <label class="oep__label">Descreva a unidade</label>
              <input
                v-model="form.location"
                type="text"
                class="form-control form-control-sm"
                maxlength="180"
                placeholder="Ex: CER Barra da Tijuca"
              >
            </div>
            <div class="oep__campo">
              <label class="oep__label">Profissional respons&aacute;vel</label>
              <input
                v-model="form.responsible_name"
                type="text"
                class="form-control form-control-sm"
                maxlength="180"
                placeholder="Quem recebeu"
              >
            </div>
          </div>
          <div class="oep__form-acoes">
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              :disabled="salvando"
              @click="fecharFormulario"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-sm btn-warning"
              :disabled="salvando || !quantidadeValida"
              @click="reter"
            >
              {{ salvando ? 'Salvando...' : 'Confirmar reten&ccedil;&atilde;o' }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ApiErrorMixin from '@/mixins/ApiErrorMixin'
import EquipmentRetentionEventsMixin from '@/mixins/EquipmentRetentionEventsMixin'
import SignatureViewer from '@/components/SignatureViewer.vue'

export default {
  name: 'OccurrenceEquipmentPanel',
  components: { SignatureViewer },
  mixins: [ApiErrorMixin, EquipmentRetentionEventsMixin],

  props: {
    occurrenceId: { type: [Number, String], default: null },
    standalone: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },

  data() {
    return {
      resumo: null,
      carregando: false,
      salvando: false,
      alvo: null,
      editando: null,
      edicao: { establishment_id: null, location: '', responsible_name: '' },
      baixando: null,
      baixa: { quantity: 1, responsible_name: '', notes: '' },
      unidades: [],
      form: {
        quantity: 1, location: '', establishment_id: null, responsible_name: '',
      },
    }
  },

  computed: {
    retencoes() {
      return (this.resumo && this.resumo.retentions) || []
    },

    retencoesAbertas() {
      return this.retencoes.filter(r => !r.returned_at)
    },

    retencoesDevolvidas() {
      return this.retencoes.filter(r => r.returned_at)
    },

    equipamentoDasEquipes() {
      return (this.resumo && this.resumo.team_equipment) || []
    },

    equipesDespachadas() {
      return (this.resumo && this.resumo.teams) || []
    },

    posicaoLiberadora() {
      return (this.resumo && this.resumo.unlock_position) || null
    },

    textoBloqueio() {
      return this.posicaoLiberadora
        ? `Disponível a partir de ${this.posicaoLiberadora}`
        : 'Indisponível para esta equipe'
    },

    alvoAtual() {
      return this.equipamentoDasEquipes.find(a => a.id === this.alvo) || null
    },

    quantidadeValida() {
      const q = Number(this.form.quantity)
      return this.alvoAtual !== null && q >= 1 && q <= this.alvoAtual.quantity
    },
  },

  watch: {
    occurrenceId: {
      immediate: true,
      handler() {
        this.resumo = null
        this.fecharFormulario()
        this.carregar()
      },
    },
  },

  mounted() {
    this.carregarUnidades()
    this.watchRetentionEvents()
  },

  methods: {
    async carregar() {
      if (!this.occurrenceId) return

      this.carregando = true
      try {
        const res = await this.$http.get(
          `${this.$store.state.api}occurrences/${this.occurrenceId}/equipment`,
        )
        this.resumo = res.data.data || null
        this.$emit('carregado', this.resumo)
      } catch (e) {
        this.resumo = null
        this.$message('Erro', this.apiErrorText(e, 'Não foi possível carregar os equipamentos.'), 'error')
      } finally {
        this.carregando = false
      }
    },

    podeReter(a) {
      return a.can_retain !== false
    },

    onRetentionEvent(payload) {
      if (Number(payload.occurrence_id) !== Number(this.occurrenceId)) return
      this.carregar()
    },

    async carregarUnidades() {
      if (this.readonly) return

      try {
        const res = await this.$http.get(`${this.$store.state.api}establishments`, {
          params: { paginated: false, status: 1 },
        })
        this.unidades = res.data.data || []
      } catch (e) {
        this.unidades = []
      }
    },

    destino(r) {
      if (r.establishment && r.establishment.establishment_name) return r.establishment.establishment_name

      return r.location || 'local não informado'
    },

    urlAssinatura(r) {
      return `${this.$store.state.api}equipment/retentions/${r.id}/signature`
    },

    abrirEdicao(r) {
      this.editando = this.editando === r.id ? null : r.id
      this.baixando = null
      this.edicao = {
        establishment_id: r.establishment_id || null,
        location: r.location || '',
        responsible_name: r.responsible_name || '',
      }
    },

    async salvarEdicao(r) {
      this.salvando = true
      try {
        await this.$http.put(`${this.$store.state.api}equipment/retentions/${r.id}`, {
          establishment_id: this.edicao.establishment_id || null,
          location: this.edicao.location || null,
          responsible_name: this.edicao.responsible_name || null,
        })
        this.$message('Sucesso', 'Retenção atualizada.', 'success')
        this.editando = null
        await this.carregar()
      } catch (e) {
        this.$message('Erro', this.apiErrorText(e, 'Não foi possível salvar.'), 'error')
      } finally {
        this.salvando = false
      }
    },

    abrirBaixa(r) {
      this.baixando = this.baixando === r.id ? null : r.id
      this.editando = null
      this.baixa = { quantity: r.pending_quantity, responsible_name: '', notes: '' }
    },

    baixaValida(r) {
      const q = Number(this.baixa.quantity)

      return q >= 1 && q <= r.pending_quantity
    },

    baixaParcial(r) {
      return this.baixaValida(r) && Number(this.baixa.quantity) < r.pending_quantity
    },

    async confirmarBaixa(r) {
      if (!this.baixaValida(r)) return

      this.salvando = true
      try {
        await this.$http.post(`${this.$store.state.api}equipment/retentions/${r.id}/return`, {
          quantity: Number(this.baixa.quantity),
          responsible_name: this.baixa.responsible_name || null,
          notes: this.baixa.notes || null,
        })
        this.$message('Sucesso', 'Recuperação registrada.', 'success')
        this.baixando = null
        await this.carregar()
      } catch (e) {
        this.$message('Erro', this.apiErrorText(e, 'Não foi possível dar baixa.'), 'error')
      } finally {
        this.salvando = false
      }
    },

    abrirFormulario(a) {
      if (!this.podeReter(a)) return

      this.alvo = a.id
      this.form.quantity = a.quantity
      this.form.location = ''
      this.form.establishment_id = null
      this.form.responsible_name = ''
    },

    fecharFormulario() {
      this.alvo = null
      this.form.quantity = 1
      this.form.location = ''
      this.form.establishment_id = null
      this.form.responsible_name = ''
    },

    async reter() {
      if (!this.quantidadeValida) return

      this.salvando = true
      try {
        await this.$http.post(
          `${this.$store.state.api}occurrences/${this.occurrenceId}/equipment-retentions`,
          {
            allocation_id: this.alvo,
            quantity: Number(this.form.quantity),
            establishment_id: this.form.establishment_id || null,
            location: this.form.location || null,
            responsible_name: this.form.responsible_name || null,
          },
        )
        this.$message('Sucesso', 'Retenção registrada.', 'success')
        this.fecharFormulario()
        await this.carregar()
      } catch (e) {
        this.$message('Erro', this.apiErrorText(e, 'Não foi possível registrar a retenção.'), 'error')
      } finally {
        this.salvando = false
      }
    },

    detalheEquipamento(equipment) {
      if (!equipment) return ''

      const unidade = (equipment.unit && equipment.unit.abbreviation)
        || (equipment.type && equipment.type.unit && equipment.type.unit.abbreviation)
        || ''
      const partes = []

      if (equipment.measure_value) partes.push(`${equipment.measure_value} ${unidade}`.trim())
      if (equipment.serial) partes.push(equipment.serial)

      return partes.join(' · ')
    },

    nomeEquipamento(equipment) {
      if (!equipment) return '—'

      const unidade = (equipment.unit && equipment.unit.abbreviation)
        || (equipment.type && equipment.type.unit && equipment.type.unit.abbreviation)
        || ''
      const medida = equipment.measure_value ? ` · ${equipment.measure_value} ${unidade}`.trimEnd() : ''
      const serie = equipment.serial ? ` · ${equipment.serial}` : ''

      return `${equipment.name}${medida}${serie}`
    },
  },
}
</script>

<style scoped>
.oep {
  border-top: 1px solid #ebe9f1;
  padding-top: 12px;
  margin-bottom: 12px;
}

.oep--solto {
  border-top: none;
  padding-top: 0;
  margin-bottom: 0;
}

.oep__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.oep__title {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6e6b7b;
}

.oep__refresh {
  padding: 0;
  font-size: 12px;
}

.oep__vazio {
  padding: 10px 0;
  text-align: center;
}

.oep__aviso {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12.5px;
  line-height: 1.5;
}

.oep__aviso--retido {
  background: #fdf3e4;
  color: #b45309;
}

.oep__aviso--ok {
  background: rgba(40, 199, 111, 0.12);
  color: #28c76f;
}

.oep__ret {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed rgba(180, 83, 9, 0.25);
}

.oep__ret:first-child {
  margin-top: 4px;
  padding-top: 0;
  border-top: none;
}

.oep__ret-topo {
  display: flex;
  align-items: center;
  gap: 6px;
}

.oep__ret-qtd {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.oep__ret-parcial {
  font-size: 10.5px;
  opacity: 0.8;
}

.oep__parcial {
  margin-top: 8px;
  font-size: 11.5px;
  font-weight: 600;
}

.oep__form--baixa {
  border-color: rgba(40, 199, 111, 0.35);
  background: rgba(40, 199, 111, 0.06);
}

.oep__selo-pendente {
  margin-left: auto;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 2px 7px;
  border-radius: 10px;
  background: rgba(180, 83, 9, 0.15);
}

.oep__ret-linha {
  font-size: 11.5px;
  opacity: 0.85;
  margin-top: 1px;
}

.oep__ret-acoes {
  display: flex;
  align-items: center;
  gap: 12px;
  opacity: 1;
  margin-top: 3px;
}

.oep__acao {
  font-size: 11.5px;
  font-weight: 600;
}

.oep__acao--baixa {
  color: #28c76f;
}

.oep__form--edicao {
  border-color: #d8d6de;
  background: #fbfbfc;
}

.dark-layout .oep__form--edicao {
  border-color: #3b4253;
  background: #262d42;
}

.oep__recuperados {
  margin-top: 6px;
  font-size: 11.5px;
  color: #8592a3;
}

.oep__gate {
  margin-bottom: 6px;
  font-size: 11.5px;
  color: #8592a3;
}

.oep__sem-equipamento {
  margin-top: 12px;
  font-size: 12.5px;
  color: #8592a3;
}

.oep__sub {
  margin: 12px 0 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8592a3;
}

.oep__linha {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #f3f2f7;
  font-size: 13px;
}

.oep__linha:last-child {
  border-bottom: none;
}

.oep__linha--bloqueada {
  opacity: 0.6;
}

.oep__item {
  min-width: 0;
  flex: 1 1 auto;
}

.oep__pastilha {
  flex: 0 0 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: rgba(115, 103, 240, 0.12);
  color: #7367f0;
  font-weight: 600;
  font-size: 12.5px;
  font-variant-numeric: tabular-nums;
}

.oep__nome {
  font-weight: 600;
  color: #5e5873;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.oep__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 2px;
}

.oep__detalhe {
  font-size: 11.5px;
  color: #8592a3;
}

.oep__chip {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.02em;
  padding: 2px 7px;
  border-radius: 10px;
  background: #f3f2f7;
  color: #6e6b7b;
}

.oep__form {
  margin-top: 8px;
  padding: 10px 12px;
  border: 1px solid #f0e0c0;
  border-radius: 6px;
  background: #fffaf1;
}

.oep__form-topo {
  font-size: 12.5px;
  margin-bottom: 6px;
}

.oep__form-campos {
  display: flex;
  gap: 10px;
}

.oep__campo {
  flex: 1 1 auto;
  min-width: 0;
}

.oep__campo--qtd {
  flex: 0 0 96px;
}

.oep__label {
  display: block;
  margin-bottom: 2px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #8592a3;
}

.oep__form-acoes {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}

/* dark mode */
.dark-layout .oep {
  border-top-color: #3b4253;
}

.dark-layout .oep__title {
  color: #b4b7bd;
}

.dark-layout .oep__aviso--retido {
  background: #2e2214;
  color: #e5a95c;
}

.dark-layout .oep__linha {
  border-bottom-color: #3b4253;
}

.dark-layout .oep__nome {
  color: #d0d2d6;
}

.dark-layout .oep__chip {
  background: #343d55;
  color: #b4b7bd;
}

.dark-layout .oep__form {
  border-color: #4a3d28;
  background: #262d42;
}
</style>
